import { useQuery } from 'react-query'

import { workspaceApiRequest } from '../../global/api/api'

const useCategoryListQuery = () => {
  return useQuery({
    queryKey: ['categories', 'list'],
    queryFn: async () =>
      workspaceApiRequest('video-categories', 'get', { size: 100 }),
    keepPreviousData: true,
    staleTime: 60 * 60 * 1000, // 1 hour
  })
}

export { useCategoryListQuery }
